<template>
  <div class="create-job-profile-view d-flex flex-column h-100 bg-white">
    <Transition
      name="step-fade"
      mode="out-in"
    >
      <CreateJobProfileStep1
        v-if="store.step === 1"
        key="step1"
      />
      <CreateJobProfileStep2
        v-else-if="store.step === 2"
        key="step2"
      />
    </Transition>
  </div>
</template>

<script setup>
import { onUnmounted } from 'vue';
import { useCreateJobProfileWizard } from '@/stores/jobProfiles/createJobProfileWizard';
import CreateJobProfileStep1 from '@/components/jobProfiles/wizard/CreateJobProfileStep1.vue';
import CreateJobProfileStep2 from '@/components/jobProfiles/wizard/CreateJobProfileStep2.vue';

const store = useCreateJobProfileWizard();

onUnmounted(() => {
  store.reset();
});
</script>

<style scoped>
.create-job-profile-view {
  height: 100%;
  overflow: hidden;
}

.step-fade-enter-active,
.step-fade-leave-active {
  transition: opacity 0.15s ease;
}

.step-fade-enter-from,
.step-fade-leave-to {
  opacity: 0;
}
</style>
